import Phaser from 'phaser';

import { GameAsset } from '../../services/asset-catalogue-service';
import { PileViewModel } from './pile-view-model';
import { SolitaireMainScene } from '../../scenes/solitaire-main-scene';
import { ResizeMetrics } from '../../resize-metrics';

export abstract class PileView extends Phaser.GameObjects.Container {
  protected viewModel: PileViewModel;
  protected background: Phaser.GameObjects.Image;

  constructor(scene: SolitaireMainScene, x: number, y: number, viewModel: PileViewModel) {
    super(scene, x, y);

    this.viewModel = viewModel;

    const backgroundAsset = viewModel.backgroundAsset;
    this.background = scene.add.image(0, 0, backgroundAsset.type).setOrigin(0, 0);

    this.add([this.background]);
    this.setName(PileView.name);
    scene.add.existing(this);
  }

  public onResize(resizeMetrics: ResizeMetrics) {
    this.resizeBackground(resizeMetrics, this.viewModel.backgroundAsset);
  }

  protected abstract resizeBackground(resizeMetrics: ResizeMetrics, gameAsset: GameAsset): void;
}
